"use client";

import { useState } from "react";
import { ToastContainer } from "react-toastify";

import { useTheme } from "next-themes";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";

import NavItem from "./nav-item";
import { headerItems } from "./navigation.config";
import UserDropdown from "./user-dropdown";

// import ThemeSelector from "./theme-selector";

export default function PrimaryNavbar() {
  const { theme, systemTheme } = useTheme();

  const [offcanvasOpen, setOffcanvasOpen] = useState(false);

  const pathname = usePathname();

  const handleClose = () => {
    setOffcanvasOpen(false);
  };

  const handleShow = () => {
    setOffcanvasOpen(true);
  };

  return (
    <Navbar
      expand={"lg"}
      className="bg-body-tertiary"
      id="navbar"
      style={{ boxShadow: "0 10px 15px rgb(25 25 25 / 10%)" }}
    >
      <ToastContainer position="top-right" autoClose={10_000} theme={theme === "system" ? systemTheme : theme} />
      <Container>
        <Link href={"/"} className="navbar-brand">
          <Image
            src={"/logo.png"}
            width="55"
            height="55"
            alt="Gateway to global aging data logo"
            className="d-inline-block align-top"
          />
        </Link>
        <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={handleShow} />
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end"
          show={offcanvasOpen}
          onHide={handleClose}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Menu</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-center flex-grow-1 pe-3">
              {headerItems.map((item) => (
                <NavItem key={item.id} item={item} pathname={pathname} handleClose={handleClose} />
              ))}
            </Nav>
            <div className="d-flex align-items-center">
              {/* <ThemeSelector /> */}
              <UserDropdown handleClose={handleClose} />
            </div>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
}
